import SidebarEstande from '../../Layouts/SidebarEstandes';
import TelaMapaFeira from '../../pages/Vendas/TelaMapaFeira';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import { useState, useEffect, useMemo } from 'react';
import {
  Row,
  Col,
  Container
} from "reactstrap";
import { fetchComAuthJson } from '../../common/api';
import { api } from "../../config";
import { FeiraProvider } from "../../Contexts/FeiraContext";
import "../../assets/scss/mapa-interno/interno.scss";

const MapaInterno = () => {
  const [feirasDisponiveis, setFeirasDisponiveis] = useState([]);
  const [feiraSelecionada, setFeiraSelecionada] = useState(null);
  const [isLoadingFeiras, setIsLoadingFeiras] = useState(false);
  const [error, setError] = useState(null);

  const [authUser, setAuthUser] = useState(() => {
    try {
      return JSON.parse(sessionStorage.getItem("authUser")) || {};
    } catch (e) {
      return {};
    }
  });

  const userData = useMemo(() => authUser.user || authUser, [authUser]);

  useEffect(() => {
    const carregarFeiras = async () => {
      setIsLoadingFeiras(true);
      try {
        const response = await fetchComAuthJson(`${api.API_URL}/feiras`);
        const data = await response.json();

        const permitidas = ['JOTAPIX', 'EVOMAP'].includes(userData.tipo) ? data.data : 
          (data.data || []).filter(feira => {
            return userData.permissoes?.permissoes?.some(p =>
              p.chave === "MAPA_INTERNO" && p.feira === feira.id
            );
          }); 

        setFeirasDisponiveis(permitidas);

        if (permitidas.length === 1) {
          const feira = permitidas[0];
          setFeiraSelecionada(feira.id.toString());
        }
      } catch (err) {
        setError("Erro ao carregar feiras");
      } finally {
        setIsLoadingFeiras(false);
      }
    };

    carregarFeiras();
  }, [userData]);

  useEffect(() => {
    if (feiraSelecionada) {
      document.documentElement.setAttribute("data-sidebar-size", "sm");

      const hamburger = document.getElementById("topnav-hamburger-icon");
      if (hamburger) {
        hamburger.classList.add("active");
      }
    }

    return () => {
      document.documentElement.setAttribute("data-sidebar-size", "lg");

      const hamburger = document.getElementById("topnav-hamburger-icon");
      if (hamburger) {
        hamburger.classList.remove("active");
      }
    };
  }, [feiraSelecionada]);

  const handleSelecionarFeira = (e) => {
    const value = e.target.value;
    setFeiraSelecionada(value || null);
  };

  document.title = "Mapa | EVOMAP - Tecnologia que conecta negócios";

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Mapa" pageTitle="Vendas" />

        <Row className="mb-3">
          <Col md={6}>
            <label className="form-label" htmlFor="feira-select-dash">
              Selecione a Feira
            </label>
            <select
              id="feira-select-dash"
              className="form-select"
              value={feiraSelecionada || ''}
              onChange={handleSelecionarFeira}
              disabled={isLoadingFeiras}
            >
              <option value="">Selecione...</option>
              {feirasDisponiveis.map(feira => (
                <option key={feira.id} value={feira.id.toString()}>
                  {feira.nome}
                </option>
              ))}
            </select>
          </Col>
        </Row>

        {feiraSelecionada && (
          <div className="modulo-vendas-container mapa-interno-container">
            <div className="app-frame mapa-interno-frame">
              <FeiraProvider idFeira={feiraSelecionada}>
                <div className="layout-interno layout-mapa-interno">
                  <TelaMapaFeira isVisualizacaoInterna />
                  <SidebarEstande
                    isVisualizacaoInterna
                    modoModal
                  />
                </div>
              </FeiraProvider>
            </div>
          </div>
        )}
      </Container>
    </div>
  );
};

export default MapaInterno;